
import { Component, Vue } from "vue-property-decorator";
import FormularioComponent from "@/components/Formulario2026/FormularioProntoComponent.vue";

@Component({
  components: {
    FormularioComponent
  }
})
export default class FormularioProntoView extends Vue {}
